/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Sla_EnforcementInputs */

const en_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA enforcement`)
};

const ar_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تطبيق SLA`)
};

const bn_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA এনফোর্সমেন্ট`)
};

const de_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA-Durchsetzung`)
};

const es_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumplimiento de SLA`)
};

const fr_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application du SLA`)
};

const pt_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicação do SLA`)
};

const zh_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA 执行`)
};

const tr_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA'nın uygulanması`)
};

const ru_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обеспечение соблюдения SLA`)
};

const pl_svchip_sla_enforcement = /** @type {(inputs: Svchip_Sla_EnforcementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egzekwowanie umowy SLA`)
};

/**
* | output |
* | --- |
* | "SLA enforcement" |
*
* @param {Svchip_Sla_EnforcementInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_sla_enforcement = /** @type {((inputs?: Svchip_Sla_EnforcementInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Sla_EnforcementInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_sla_enforcement(inputs)
	if (locale === "bn") return bn_svchip_sla_enforcement(inputs)
	if (locale === "de") return de_svchip_sla_enforcement(inputs)
	if (locale === "es") return es_svchip_sla_enforcement(inputs)
	if (locale === "fr") return fr_svchip_sla_enforcement(inputs)
	if (locale === "pt") return pt_svchip_sla_enforcement(inputs)
	if (locale === "zh") return zh_svchip_sla_enforcement(inputs)
	if (locale === "tr") return tr_svchip_sla_enforcement(inputs)
	if (locale === "ru") return ru_svchip_sla_enforcement(inputs)
	if (locale === "pl") return pl_svchip_sla_enforcement(inputs)
	return en_svchip_sla_enforcement(inputs)
});